import { render, staticRenderFns } from "./deal-center-info.vue?vue&type=template&id=86d07a84&scoped=true&"
import script from "./deal-center-info.vue?vue&type=script&lang=js&"
export * from "./deal-center-info.vue?vue&type=script&lang=js&"
import style0 from "./deal-center-info.vue?vue&type=style&index=0&id=86d07a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d07a84",
  null
  
)

export default component.exports